import invariant from "invariant";
import * as React from "react";
import { useSelector } from "react-redux";

import { getToken } from "@/features/authentication/authentication-reducer";
import { fetchJSON } from "@/utils/fetchJSON";

export default function useFetch() {
  const token = useSelector(getToken);

  const authenticatedFetch = React.useCallback(
    <T,>(route: string, options: any = {}) => {
      invariant(token, "Missing authentication token");

      return fetchJSON<T>(route, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${token}`,
        },
      });
    },
    [token]
  );

  return {
    fetch: fetchJSON,
    authenticatedFetch,
  };
}
